/**
 * 检查对应的插件方法是否可用
 * @param {} name
 */
export function canUse(name) {
  return !!(window.zzcjsbridge && window.zzcjsbridge[name]);
}

/**
 * GrowingIO统计事件埋点
 * @param {String} action 埋点事件标识符、页面级变量上报事件(PageVariable)、转化变量(Evariable)、登录用户id+变量(PeopleVariable)
 * @param {*} dataStr 自定义上报字段
 */
export function growingIoPoint({ action = '', dataStr }) {
  let param = dataStr;
  if (param instanceof Object) {
    param = JSON.stringify(param);
  }
  return new Promise((resolve) => {
    if (!canUse('growingIO')) {
      return;
    }
    window.zzc.call('growingIO', {
      action,
      dataStr: param,
      success: (respone) => {
        resolve(respone);
      },
    });
  });
}
